import { KeystoneProvider } from '@rtaoutdoorlivingllc/keystone-react';
import { useKeystoneSession } from '../auth/use-keystone-session';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';

import { AppGlobalProvider } from '.';
import { keystoneConfig, useDevSession } from '../auth';
import { AppToastProvider } from '../components/toast';
import { LoginPage } from '../pages/login-page';
import { rtaTheme } from '../theme';

import { lazy, Suspense } from 'react';

import type { JSX, ReactNode } from 'react';

const DevBridge = import.meta.env.DEV
	? lazy(() => import('@rta/dev-bridge').then((m) => ({ default: m.DevBridge })).catch(() => ({ default: () => null })))
	: null;

const AuthGate = ({ children }: { children?: ReactNode }): JSX.Element => {
	const { active: devBypassActive } = useDevSession();
	const { status } = useKeystoneSession();

	if (devBypassActive || status === 'ready') {
		return <AppGlobalProvider>
			{children}
			{DevBridge && <Suspense><DevBridge /></Suspense>}
		</AppGlobalProvider>;
	}

	return <LoginPage />;
};

export const AppAuthProvider = ({ children }: { children?: ReactNode }): JSX.Element => {
	return <KeystoneProvider config={keystoneConfig}>
		<ChakraProvider theme={rtaTheme}>
			<AppToastProvider>
			<ColorModeScript />
			<AuthGate>{children}</AuthGate>
			</AppToastProvider>
		</ChakraProvider>
	</KeystoneProvider>;
};
